<template>
  <div class="homeRaise">
    <div v-if="carouselList[0]" class="carousel">
      <el-carousel
        :autoplay="true"
        :style="{ background: carouselList[0].background }"
      >
        <el-carousel-item v-for="item of carouselList" :key="item.url">
          <el-image
            :src="item.url"
            fit="cover"
            @click="clickCarousel(item)"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="HomeContainer">
      <div class="orderContainer">
        <div
          class="orderItem"
          style="width: 84px"
          :class="{ active: !Sorting }"
          @click="
            Sorting = null;
            GetTableList(true);
          "
        >
          {{l("综合")}}
        </div>
        <div
          class="orderItem"
          :class="{ active: Sorting == 'is_expire,-created_time' }"
          @click="
            Sorting = 'is_expire,-created_time';
            GetTableList(true);
          "
        >
          {{l("最新发布")}}<i class="el-icon-top"></i>
        </div>
        <div
          class="orderItem"
          :class="{ active: Sorting == 'is_expire,expire_time' }"
          @click="
            Sorting = 'is_expire,expire_time';
            GetTableList(true);
          "
        >
          {{l("即将截止")}}<i class="el-icon-top"></i>
        </div>
        <!-- <div class="filterItem">
        <el-checkbox
          label="仅显示可参与"
          v-model="SearchData.status"
          :true-label="1"
          false-label=""
          @change="GetTableList(true)"
        ></el-checkbox>
      </div> -->
      </div>

      <template v-if="TableList.length">
        <div class="raiseContainer">
          <router-link
            v-for="item of TableList"
            :key="item.id"
            :to="'/home/raise/' + item.code"
            target="_blank"
            class="raiseItem"
          >
            <el-image
              class="img_array"
              :src="item.img_array[0]"
              fit="cover"
            ></el-image>

            <div class="detail">
              <el-image
                v-if="item.status == 2"
                key="icon-expire"
                class="icon-expire"
                :src="GetResourceUrl('home/icon-expire.svg')"
              ></el-image>
              <div class="title one_lines">
                {{ item.title }}
              </div>
              <div class="price one_lines">
                {{ item.specification_amount[0].price }}{{l("元")}}/{{
                  item.specification_amount[0].unit
                }}
              </div>

              <div class="progressContainer">
                <div class="progressBar">
                  <div
                    class="innerBar"
                    :style="{
                      width: (item.rate_amount / item.amount) * 100 + '%',
                    }"
                  ></div>
                </div>
                <div class="rate_amount">
                  <span class="color-warning"
                    >{{ item.rate_amount
                    }}{{ item.specification_amount[0].unit }}</span
                  >/{{ item.amount }}{{ item.specification_amount[0].unit }}
                </div>
              </div>
              <div class="line">
                {{l("起拼量")}}：{{ item.start_amount
                }}{{ item.specification_amount[0].unit }}
              </div>
              <div class="line" style="margin-top: 8px">
                {{l("截止日期")}}：{{ item.expire_time.slice(0, 10) }}
              </div>
              <div v-if="item.status == 1" key="status1" class="btn">
                {{l("参与拼单")}}
              </div>
              <div
                v-else-if="item.status == 2"
                key="status2"
                class="btn_status2"
              >
                {{l("拼单已截止")}}
              </div>
            </div>
          </router-link>
        </div>

        <el-pagination
          style="justify-content: center"
          background
          @current-change="HandleCurrentChange"
          :current-page="CurrentPage"
          :page-size="PageSize"
          layout="total, prev, pager, next, jumper"
          :total="TotalCount"
        ></el-pagination>
      </template>
      <el-empty v-else :description="l('暂无内容')"></el-empty>
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";

export default {
  name: "HomeRaise",
  mixins: [tableMixin],
  data() {
    return {
      PageSize: 8,
      SearchData: {
        title: this.$store.state.headerFilter,
        status: "",
      },
      carouselList: [],
    };
  },
  created() {
    this.getCarousel();
  },
  mounted() {
    this.$EventBus.$on("headerSearch", ({ filterText }) => {
      this.SearchData.title = filterText;
      this.GetTableList(true);
    });
  },
  beforeDestroy() {
    this.$EventBus.$off("headerSearch");
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get("/api/visitor_raise/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results.map((item) => {
            try {
              item.img_array = JSON.parse(item.img_array);
            } catch (e) {
              console.error(e);
            }
            return item;
          });
        });
    },
    getCarousel() {
      this.axios
        .get("/api/banner/", {
          params: {
            position: "carousel_raise",
            show_pc: true,
            is_show: true,
          },
        })
        .then((data) => {
          this.carouselList = data;
        });
    },
    clickCarousel(item) {
      if (item.path_pc) {
        if (item.path_pc.indexOf("http") == 0) {
          window.open(item.path_pc);
        } else {
          this.$router.push({ path: item.path_pc });
        }
      }
    },
  },
};
</script>


<style scoped lang="scss">
.carousel {
  max-width: 1920px;
  margin: 0 auto;
  width: 100%;
  height: 190px;
  position: relative;
  .el-carousel {
    width: 100%;
    height: 100%;
    /deep/.el-carousel__container {
      height: 100%;
      .el-carousel__item {
        height: 100%;
      }

      .el-carousel__item .el-image {
        height: 100%;
        width: 100%;
      }
    }
  }
}
.raiseContainer {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 15px;

  .raiseItem {
    display: flex;
    width: 594px;
    height: 216px;
    background: #fff;
    margin-bottom: 15px;
    position: relative;
    padding: 15px;
    box-sizing: border-box;

    .img_array {
      width: 206px;
      height: 186px;
    }

    .detail {
      width: 325px;
      height: 100%;
      margin-left: 34px;
      position: relative;
      .icon-expire {
        position: absolute;
        width: 81px;
        height: 76px;
        right: 0;
        top: 0;
        opacity: 0.6;
      }
      .title {
        font-size: 18px;
        margin-top: 10px;
      }
      .price {
        color: $warningColor;
        height: 35px;
        line-height: 35px;
        margin-top: 5px;
        // font-weight: bold;
        font-size: 17px;
        letter-spacing: 0.5px;
      }
      .progressContainer {
        margin-top: 20px;
        margin-right: 15px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        .progressBar {
          max-width: 210px;
          flex-grow: 1;
          flex-shrink: 1;
          height: 4px;
          background: $borderPlainColor;
          border-radius: 5px;
          margin-right: 50px;

          overflow: hidden;
          .innerBar {
            border-radius: 5px;
            background: $warningColor;
            height: 100%;
          }
        }
        .rate_amount {
          flex-shrink: 0;
          letter-spacing: 0.5px;
          color: #999;
        }
      }
      .btn {
        border: 1px solid $warningColor;
        color: $warningColor;
        border-radius: 5px;
        text-align: center;
        width: 78px;
        height: 32px;
        line-height: 32px;
        box-sizing: border-box;
        position: absolute;
        bottom: 16px;
        right: 15px;
        cursor: pointer;
        &:hover {
          color: #fff;
          background: $warningColor;
        }
      }
      .btn_status2 {
        color: #999;
        box-sizing: border-box;
        position: absolute;
        bottom: 24px;
        right: 15px;
      }
    }
  }
}
.orderContainer {
  margin-top: 12px;
  display: flex;
  line-height: 45px;
  text-align: center;
  border: 1px solid $borderPlainColor;
  box-sizing: border-box;
  background: #fff;

  .orderItem {
    box-sizing: border-box;
    padding: 0 18px;
    border-right: 1px solid $borderPlainColor;
    cursor: pointer;
    &.active {
      color: $warningColor;
    }
  }
  .filterItem {
    padding: 0 20px;
    display: flex;
    align-items: center;
    // border-right: 1px solid $borderPlainColor;
    .label {
      margin-right: 10px;
    }
  }
}
/deep/.el-empty {
  background: #fff;
}
</style>

